import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IntInputComponent } from './int-input.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule],
  declarations: [
    IntInputComponent
  ],
  exports: [
    IntInputComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class IntInputModule {}
